const BASE_URL = process.env.REACT_APP_API_CALL_BASE_URL;
//DELETE assignments
export const handleDelete = async(room, dayIso, assignmentId, setAssignments, token) => {
    if (!assignmentId) return;

    try {
      const response = await fetch(`${BASE_URL}/invoco/assignments/${assignmentId}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!response.ok) throw new Error ('Delete failed');

      const result = await response.json();

      if (result.deleted) {
        setAssignments(prev => {
          const updated = { ...prev };
          if (updated[room.room_id] && updated[room.room_id][dayIso]) {
            delete updated[room.room_id][dayIso];
          }
          return updated;
        });
      }
    } catch (error) {
      console.error('Delete failed', error);
    }
  }

  // Context menu for deleting assignments
  export  const handleRightClick = (event, room, dayIso, assignment, setContextMenu) => {
      event.preventDefault();
      if (!assignment?.assignment_id) return;
  
      setContextMenu({
        x: event.clientX,
        y: event.clientY,
        room,
        dayIso,
        assignment,
      });
      console.log(event.clientX, event.clientY)
    };

// Hold down to delete on mobile / hold mouse down 
// TODO - TEST ON MOBILE
export const handleTouchStart = (event, room, dayIso, assignment, touchTimerRef, setContextMenu) => {
  if (!assignment?.assignment_id) return;
   touchTimerRef.current = setTimeout(() => {
    let x, y;
    if (event.touches && event.touches[0]) {
      // real touch - need to test on mobile
      x = event.touches[0].clientX;
      y = event.touches[0].clientY;
    } else {
      // testing with mousedown
      x = event.clientX;
      y = event.clientY;
    }

    setContextMenu({ x, y, room, dayIso, assignment })
   }, 600) 
}

// Reset timer when "letting go" of holding down cell
export const handleTouchEnd = (touchTimerRef) => {
  if (touchTimerRef.current) {
    clearTimeout(touchTimerRef.current);
    touchTimerRef.current = null;

  }
}